import {groupBy, sortBy} from "lodash";
import {SimpleFacilityModel} from "../../utils/types/facility";

export const createFacilitiesTree = (
  facilities: ReadonlyArray<SimpleFacilityModel> | null,
) => {
  if (!facilities || facilities.length === 0) {
    return [];
  }
  return sortBy(
    Object.entries(
      groupBy(facilities, ({organization}) => organization.id),
    ).map(([organizationId, facilities]) => ({
      key: organizationId,
      title: facilities[0].organization.name,
      children: sortBy(
        facilities.map(({id, name, pccIntegrationStatus}) => ({
          key: id,
          title: name,
          pccIntegrationStatus,
        })),
        "title",
      ),
    })),
    "title",
  );
};
